export const Resources = {
  menu: "Protein.JTP.MasterData.Menu",
  department: "Protein.JTP.MasterData.Department",
  impersonate: "Protein.JTP.ImpersonateUser",
  notificationTemplate: "Protein.JTP.MasterData.EmailTemplate",
  configuration: "Protein.JTP.MasterData.Configuration",
  widget: "Protein.JTP.MasterData.Widget",
  businessArea: "Protein.JTP.MasterData.BusinessArea",
  policy: {
    approvalGroup: "Protein.JTP.Policy.ApprovalGroup",
    attribute: "Protein.JTP.Policy.Attribute",
    policyType: "Protein.JTP.Policy.PolicyType",
    workflow: "Protein.JTP.Policy.Workflow",
    document: "Protein.JTP.Policy.Document",
  },
}
